import { makeAutoObservable } from 'mobx'
import {
  ChatbotInstructionType,
  type IChatbotSettings,
  type IChatbotPayload,
  type ChatbotStatus,
} from '../type'
import { ChatbotAutoFollowUp } from './ChatbotAutoFollowUp'
import { ChatbotBooking } from './ChatbotBooking'
import { ChatbotInstructions } from './ChatbotInstructions'
import { ChatbotKnowledgeBase } from './ChatbotKnowledgeBase'
import { ChatbotTrigger } from './ChatbotTrigger'

type IUnifiedAgentPartialPayload = {
  type: ChatbotInstructionType
  is_active: boolean
  settings: IChatbotSettings | null
  success_actions: null
  fallback_actions: null
  qualified_actions: null
  disqualified_actions: null
  enroll_by_webhook: boolean
}
export class UnifiedAgent {
  readonly autoFollowUp = new ChatbotAutoFollowUp()
  readonly booking = new ChatbotBooking()
  readonly instructions = new ChatbotInstructions()
  readonly knowledgeBase = new ChatbotKnowledgeBase()
  readonly trigger = new ChatbotTrigger()
  isActive = false
  status: ChatbotStatus | null = null

  constructor() {
    makeAutoObservable(this)
  }

  syncOrigin(payload?: IChatbotPayload | null) {
    this.isActive = payload?.is_active ?? false
    this.status = payload?.status ?? null
    this.trigger.syncOrigin(payload?.settings)
    this.instructions.syncOrigin(payload?.settings)
    this.booking.syncOrigin(payload?.settings)
    this.autoFollowUp.syncOrigin(payload?.settings)
    this.knowledgeBase.syncOrigin(payload?.settings)
  }

  setActive(isActive: boolean) {
    this.isActive = isActive
  }

  toJSON(): Omit<IUnifiedAgentPartialPayload, 'enroll_by_webhook'> {
    return {
      type: ChatbotInstructionType.Unified,
      is_active: this.isActive,
      success_actions: null,
      fallback_actions: null,
      qualified_actions: null,
      disqualified_actions: null,
      settings: {
        ...this.instructions.toJSON(),
        ...this.booking.toJSON(),
        ...this.autoFollowUp.toJSON(),
        ...this.trigger.toJSON(),
        ...this.knowledgeBase.toSettingsJSON(),
      },
    }
  }
}
